module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/stuList'
      }
    }
  }, [_vm._v("学员管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(this.$route.query.id ? "编辑学员" : "添加学员"))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formStu,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员昵称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "昵称为必填项"
    },
    model: {
      value: (_vm.formStu.name),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "name", $$v)
      },
      expression: "formStu.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "300px"
    },
    attrs: {
      "label": "手机号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号为必填项"
    },
    model: {
      value: (_vm.formStu.phone),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "phone", $$v)
      },
      expression: "formStu.phone"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生年月:"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "placeholder": "出生年月",
      "format": "yyyy-MM-dd",
      "placement": "bottom-end"
    },
    model: {
      value: (_vm.formStu.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "birthday", $$v)
      },
      expression: "formStu.birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "300px"
    },
    attrs: {
      "label": "性别:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formStu.sex),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "sex", $$v)
      },
      expression: "formStu.sex"
    }
  }, _vm._l((_vm.sexList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写微信号"
    },
    model: {
      value: (_vm.formStu.weixinId),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "weixinId", $$v)
      },
      expression: "formStu.weixinId"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('Card', [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("报名信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formStu,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "定级老师:"
    }
  }, [_c('teacherSelect', {
    attrs: {
      "mainTeacherName": _vm.formStu.rateTeacher
    },
    on: {
      "teacherResult": _vm.teacherChgHandle
    }
  }, [_vm._v("选择定级老师")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名时间:"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placement": "bottom-end",
      "clearable": false
    },
    model: {
      value: (_vm.formStu.signupDate),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "signupDate", $$v)
      },
      expression: "formStu.signupDate"
    }
  })], 1), _vm._v(" "), (_vm.zxstatus != 4) ? _c('el-form-item', {
    staticStyle: {},
    attrs: {
      "label": "会员有效期:"
    }
  }, [(_vm.currId == '') ? _c('div', [_c('DatePicker', {
    attrs: {
      "options": _vm.endOptions,
      "type": "date",
      "placeholder": _vm.expireShow,
      "format": "yyyy-MM-dd",
      "placement": "bottom-end"
    },
    model: {
      value: (_vm.formStu.expireDate),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "expireDate", $$v)
      },
      expression: "formStu.expireDate"
    }
  })], 1) : _c('div', {
    staticClass: "btnFlex"
  }, [_c('span', [_vm._v(_vm._s(_vm.formStu.expireDate ? _vm.formStu.expireDate : "永久有效"))]), _vm._v(" "), _c('stuChgExpire', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "bmTime": _vm.formStu.bmTime,
      "btnSize": "mini"
    },
    on: {
      "chgExpire": _vm.chgExpireHandle
    }
  }, [_vm._v("编辑")])], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "btnFlex"
  }, [_c('stuAddClass', {
    on: {
      "classResult": _vm.classChgHandle
    }
  }, [_vm._v("分班")]), _vm._v(" "), (_vm.allClass.length) ? _c('span', {
    staticStyle: {
      "color": "green",
      "margin-left": "10px"
    }
  }, [_vm._v("班级ID：")]) : _vm._e(), _vm._v(" "), (_vm.allClass.length) ? _vm._l((_vm.allClass), function(item) {
    return _c('span', {
      staticStyle: {
        "color": "green",
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(item.classId) + "\n                  ")])
  }) : _vm._e(), _vm._v(" "), (_vm.allocatTeaClass.length) ? _c('span', {
    staticStyle: {
      "color": "green",
      "margin-left": "10px"
    }
  }, [_vm._v("老师：")]) : _vm._e(), _vm._v(" "), (_vm.allocatTeaClass.length) ? _vm._l((_vm.allocatTeaClass), function(item) {
    return _c('span', {
      staticStyle: {
        "color": "green",
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(item) + "\n                  ")])
  }) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea"
    },
    model: {
      value: (_vm.formStu.remark),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "remark", $$v)
      },
      expression: "formStu.remark"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf64642","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/stu/addStu.vue
// module id = 708
// module chunks = 1